import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import styled, { css } from 'styled-components'

import { HIGHEST_SEVERITY } from '../../constants'

const StyledTitleWithBadge = styled.div`
    display: flex;

    > div {
        display: inline;
        margin-left: auto;

        .alarm-badge {
            display: flex;
            align-items: center;

            position: absolute;
            right: 10px;
            top: 14px;

            height: 16px;
            padding: 0 4px;P
            border-radius: 2px;
            background-color: ${({ muted, color }) => (muted ? '#fff' : color)};
            border: 1px solid ${({ color }) => color};

            font-size: 11px;
            color: ${({ muted }) => (muted ? '#172033' : '#fff')};
            text-transform: lowercase;
            font-family: SourceSansPro-SemiBold;

            cursor: pointer;
            user-select: none;

            &:hover {
                .alarm-badge__text {
                    display: inline;
                }
            }

            .alarm-badge__text {
                margin-left: 2px;
                display: none;
            }

            .fas {
                margin-right: 4px;
                font-size: 12px;

                ${({ muted, color }) =>
                    muted &&
                    css`
                        color: ${color};
                    `}
            }
        }
    }
`

const Badge = ({ nAlarms, noSound, muted, onClick }) => (
    <div onClick={onClick}>
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip>
                    {noSound
                        ? 'no audio alarms set for this widget'
                        : `click to ${muted ? 'unmute' : 'mute'} this widget`}
                </Tooltip>
            }
        >
            <div className="alarm-badge">
                <i className={`fas ${noSound ? 'fa-exclamation-square' : `fa-volume-${muted ? 'mute' : 'up'}`}`} />

                <span className="alarm-badge__number">{nAlarms}</span>
                <span className="alarm-badge__text">{` alarm${nAlarms !== 1 ? 's' : ''}`}</span>
            </div>
        </OverlayTrigger>
    </div>
)

const TitleWithBadge = ({ nAlarms, severity, noSound, widget, mutedWidgets, updateMutedWidgets }) => {
    const muted = mutedWidgets[widget.id]

    return (
        <StyledTitleWithBadge muted={noSound || muted} color={severity === HIGHEST_SEVERITY ? '#D9534F' : '#F89300'}>
            {widget.title}

            <Badge
                nAlarms={nAlarms}
                noSound={noSound}
                muted={muted}
                onClick={() => updateMutedWidgets(widget.dashboard.id, widget.id, !muted)}
            />
        </StyledTitleWithBadge>
    )
}

export default TitleWithBadge
